import React from "react";
import "./AboutSection.scss";

const AboutSection = () => {
  return (
    <section className="about-section" id="nosotros">
      <div className="container">
        <div className="about-section__wrapper">
          <div className="about-section__left">
            <div className="about-section__eyebrow">Quiénes somos</div>

            <h2 className="about-section__title">
              Maquinaria industrial para empresas que buscan capacidad,
              precisión y crecimiento en su operación.
            </h2>

            <p className="about-section__description">
              Trabajamos desde
              <strong> C. Ingenieros Industriales 272, Col. Ex Hacienda de San
              Francisco Huatengo, 43774, Santiago Tulantepec, Hidalgo</strong>,
              ofreciendo una propuesta seria y especializada para clientes que
              buscan invertir en maquinaria con visión de producción y crecimiento.
            </p>

          </div>

          <div className="about-section__right">
            <div className="about-section__card about-section__card--main">
              <span className="about-section__card-label">Compromiso</span>
              <h3>Te ayudamos a encontrar el equipo adecuado para tu operación</h3>
              <p>
                Nuestro enfoque es ofrecer maquinaria que realmente se adapte al
                tipo de trabajo, capacidad de producción y objetivos de cada
                cliente, para que la inversión tenga sentido desde el rendimiento,
                la eficiencia y la proyección de crecimiento de su empresa.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;